import React, { useState, useRef, useEffect } from "react";
import "./Uploadfile.css";

const FileUploadBox = ({
  onUploadFile=()=>{},
  accept = "image/jpeg,image/png,image/jpg",
  show = false,
  fileUpload=null,
  size=0,
  title="Drag & Drop your file here or click to select a file",
  style={}
}) => {
  const [file, setFile] = useState(null);
  const [preview, setPreview] = useState("");
  const fileInputRef = useRef(null);
  const [isNotImg,setIsNotImg] =  useState(false);

  const handleFileChange = (event) => {
    try {
      const selectedFile = event.target.files[0];
     
         const fileName = selectedFile?.name;
           setFile(selectedFile);

      onUploadFile(selectedFile)
      const extension = fileName.split('.').pop().toLowerCase();
      console.log("extensionextension",extension)
      if(extension.toLowerCase() === "pdf"){
        setIsNotImg(true);
      }else{
        setIsNotImg(false);
      }
    

      if (show) {
        setPreview(URL.createObjectURL(selectedFile));
      } else {
        setPreview(selectedFile?.name);
      }
    } catch (error) {}
  };

  const handleDrop = (event) => {
    try {
      event.preventDefault();
      const droppedFile = event.dataTransfer.files[0];
      const fileName = droppedFile.name;
      const extension = fileName.split('.').pop().toLowerCase();
      console.log("extensionextension",extension)
        setFile(droppedFile);
    
      onUploadFile(droppedFile)
      if(extension.toLowerCase() === "pdf"){
        setIsNotImg(true);
      }else{
        setIsNotImg(false);
      }
    

      if (show) {
        setPreview(URL.createObjectURL(droppedFile));
      } else {
        setPreview(droppedFile?.name);
      }
    } catch (error) {}
  };

  const handleDragOver = (event) => {
    event.preventDefault();
  };

  const handleClick = () => {
    fileInputRef.current.click();
  };

  const handleRemove = (e) => {
    e.stopPropagation();
    setFile(null);
    onUploadFile(null);
    setPreview("");
    fileInputRef.current.value = null;
  };
  useEffect(() =>{
    if(!fileUpload){
      setPreview("");
      fileInputRef.current.value = null;
      setFile(null);
    }
 
  },[fileUpload])

  return (
    <div
      className={`file-upload ${(show && preview)?"has-preview":""}`}
      onDrop={handleDrop}
      onDragOver={handleDragOver}
      onClick={handleClick}
      style={style}
    >
      {preview ? (
        <div className="preview-container">
          {!show ? (
            <p>{preview}</p>
          ) : (
           <>
           {
            isNotImg?
                   <iframe id="pdfPreview" width="100%" height={"100%"} style={{border:"0"}} src={preview} ></iframe>
                   : <img
              src={preview}
              alt="Preview"
              style={{ width: "100%", height: "auto" }}
            />
           }
           
           </>
          )}

          <span className="remove-icon" onClick={handleRemove}>
            &#10005;
          </span>
        </div>
      ) : (
         <div className="center">
          <div style={{width:"72px"}}>
            <DropBoxIcon />
          </div>
         <p style={{ padding: "0 0 0 20px" }}>
         {title}
        </p>
         </div>
      )}
      <input
        type="file"
        ref={fileInputRef}
        onChange={handleFileChange}
        accept={accept}
        style={{ display: "none" }}
      />
    </div>
  );
};

export default FileUploadBox;

const DropBoxIcon = ({color = "#00276E"}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      viewBox="0 9.19 128 109.58"
    >
      <path
        d="M0 0 C1.18686401 0.70056519 1.18686401 0.70056519 2.39770508 1.4152832 C3.11869385 1.8275415 3.83968262 2.2397998 4.58251953 2.66455078 C5.6608606 3.3552063 5.6608606 3.3552063 6.76098633 4.05981445 C7.56600586 4.5722168 8.37102539 5.08461914 9.20043945 5.61254883 C10.44277344 6.41208984 10.44277344 6.41208984 11.71020508 7.2277832 C14.15652732 8.78979954 16.60288538 10.35139348 19.05639648 11.90209961 C20.59622552 12.89728838 22.11546782 13.92520999 23.61010742 14.98706055 C27.38943486 17.79115261 27.38943486 17.79115261 31.85083008 18.0559082 C32.69129883 17.51450195 33.53176758 16.9730957 34.39770508 16.4152832 C35.03256836 16.0459668 35.66743164 15.67665039 36.3215332 15.29614258 C38.62227667 13.95764034 40.88493206 12.56693694 43.14770508 11.1652832 C43.95103271 10.67455322 44.75436035 10.18382324 45.58203125 9.67822266 C50.41237064 6.71079707 55.10296587 3.64156774 59.57348633 0.14575195 C61.39770508 -0.5847168 61.39770508 -0.5847168 63.74121094 0.20654297 C66.21816157 1.33358851 68.43344167 2.56379196 70.72583008 4.0246582 C71.52633789 4.53254883 72.3268457 5.04043945 73.15161133 5.5637207 C73.97532227 6.09223633 74.7990332 6.62075195 75.64770508 7.1652832 C76.45594727 7.67833008 77.26418945 8.19137695 78.09692383 8.7199707 C83.58009208 12.21165224 89.00252966 15.78933648 94.39770508 19.4152832 C93.15320569 23.14878138 91.98973509 23.58641878 88.69848633 25.63012695 C87.73620117 26.23405273 86.77391602 26.83797852 85.7824707 27.46020508 C84.76862305 28.08475586 83.75477539 28.70930664 82.71020508 29.3527832 C80.72685011 30.59061265 78.74376967 31.82888207 76.76098633 33.06762695 C75.36420654 33.93556885 75.36420654 33.93556885 73.93920898 34.82104492 C71.05246518 36.63184579 68.21573416 38.49979155 65.39770508 40.4152832 C67.7868605 43.01967344 70.37328378 44.79224019 73.36254883 46.6652832 C74.32741211 47.2737207 75.29227539 47.8821582 76.28637695 48.5090332 C77.29249023 49.1380957 78.29860352 49.7671582 79.33520508 50.4152832 C81.32440985 51.66381302 83.31272584 52.91376026 85.30004883 54.1652832 C86.18168701 54.71700195 87.0633252 55.2687207 87.97167969 55.8371582 C90.19027408 57.28034973 92.30273243 58.79941349 94.39770508 60.4152832 C93.25397375 63.8464772 92.76810892 64.08421983 89.78442383 65.83325195 C89.03636475 66.27967041 88.28830566 66.72608887 87.51757812 67.18603516 C86.71489502 67.65356201 85.91221191 68.12108887 85.08520508 68.6027832 C78.42970758 72.53782385 72.07957528 76.6208721 65.87817383 81.24731445 C63.39770508 82.4152832 63.39770508 82.4152832 61.10620117 81.71704102 C58.09061673 80.26769035 55.37887762 78.59112999 52.58129883 76.75512695 C51.4875293 76.04420898 50.39375977 75.33329102 49.2668457 74.60083008 C47.54545261 73.47448037 45.82529869 72.34627545 44.10595703 71.21679688 C42.4341242 70.12073556 40.75776501 69.03158817 39.08129883 67.94262695 C38.08670654 67.29028076 37.09211426 66.63793457 36.06738281 65.96582031 C32.90446118 64.1130018 32.90446118 64.1130018 29.39770508 63.4152832 C27.40840069 64.14691717 27.40840069 64.14691717 25.49145508 65.44262695 C24.75306396 65.90193604 24.01467285 66.36124512 23.25390625 66.83447266 C22.47635986 67.33551514 21.69881348 67.83655762 20.89770508 68.3527832 C20.0976001 68.85189209 19.29749512 69.35100098 18.47314453 69.86523438 C14.82456733 72.15654232 11.23018648 74.49995027 7.72192383 77.0012207 C6.68680664 77.73598633 5.65168945 78.47075195 4.58520508 79.2277832 C3.24522461 80.22745117 3.24522461 80.22745117 1.87817383 81.24731445 C-0.60229492 82.4152832 -0.60229492 82.4152832 -2.89160156 81.71484375 C-5.9079197 80.26876058 -8.6434031 78.60517057 -11.45385742 76.7902832 C-13.1012793 75.73067383 -13.1012793 75.73067383 -14.78198242 74.6496582 C-15.93046869 73.90494175 -17.0789057 73.16014931 -18.22729492 72.4152832 C-19.38329504 71.67010375 -20.5395428 70.92530832 -21.69604492 70.1809082 C-25.67898907 67.61308068 -29.65922398 65.04399717 -33.60229492 62.4152832 C-32.22013404 59.07842157 -30.88829872 57.64512414 -27.78588867 55.8293457 C-27.02518066 55.37599854 -26.26447266 54.92265137 -25.48071289 54.45556641 C-24.67520996 53.98852295 -23.86970703 53.52147949 -23.03979492 53.0402832 C-21.40488774 52.0689598 -19.77076426 51.096316 -18.13745117 50.12231445 C-16.96206787 49.42549561 -16.96206787 49.42549561 -15.76293945 48.71459961 C-11.9491498 46.42115458 -8.25922829 43.94947387 -4.60229492 41.4152832 C-7.54007778 38.24240806 -10.52665387 36.08094858 -14.24291992 33.8840332 C-15.3128418 33.23821289 -16.38276367 32.59239258 -17.48510742 31.92700195 C-19.74142442 30.57897033 -22.00190349 29.23788227 -24.26635742 27.90356445 C-25.33112305 27.25774414 -26.39588867 26.61192383 -27.49291992 25.9465332 C-28.47292969 25.36452148 -29.45293945 24.78250977 -30.46264648 24.18286133 C-31.16873047 23.59956055 -31.87481445 23.01625977 -32.60229492 22.4152832 C-32.60229492 21.0952832 -32.60229492 19.7752832 -32.60229492 18.4152832 C-30.49438477 16.64770508 -30.49438477 16.64770508 -27.56323242 14.8840332 C-25.97961914 13.91530273 -25.97961914 13.91530273 -24.36401367 12.92700195 C-23.24639648 12.26313477 -22.1287793 11.59926758 -20.97729492 10.9152832 C-18.797285 9.59289792 -16.61758809 8.26999646 -14.43823242 6.9465332 C-12.97716064 6.07351563 -12.97716064 6.07351563 -11.48657227 5.18286133 C-8.50230168 3.42360092 -8.50230168 3.42360092 -5.55004883 1.06958008 C-2.60229492 -0.5847168 -2.60229492 -0.5847168 0 0 Z M24.67114258 24.30200195 C23.72110352 24.91108398 22.77106445 25.52016602 21.79223633 26.14770508 C20.29756836 27.11546875 20.29756836 27.11546875 18.77270508 28.1027832 C16.82235213 29.35695056 14.871834 30.6108611 12.92114258 31.86450195 C11.98625 32.46697754 11.05135742 33.06945313 10.08813477 33.69018555 C6.54357441 35.96294993 2.97447024 38.19361078 -0.60229492 40.4152832 C4.46759333 44.5754536 9.8679216 48.029884 15.39770508 51.5402832 C16.38254883 52.17321289 17.36739258 52.80614258 18.38208008 53.45825195 C19.81293945 54.36897461 19.81293945 54.36897461 21.27270508 55.2980957 C22.13637695 55.84868652 23.00004883 56.39927734 23.88989258 56.96655273 C27.48102454 59.08662061 27.48102454 59.08662061 31.39770508 60.4152832 C34.31288718 59.2815762 34.31288718 59.2815762 37.17895508 57.2512207 C38.8128418 56.18581055 38.8128418 56.18581055 40.47973633 55.09887695 C41.61919095 54.32954073 42.75851275 53.56000775 43.89770508 52.7902832 C45.03596164 52.0425636 46.17527571 51.29645123 47.31567383 50.55200195 C52.17690633 47.34761556 56.89150034 44.10769617 61.39770508 40.4152832 C57.89805561 38.18556587 54.39792142 35.95661053 50.89770508 33.7277832 C49.91543945 33.10194336 48.93317383 32.47610352 47.92114258 31.83129883 C45.98603421 30.59927983 44.04985521 29.36894066 42.11254883 28.14038086 C40.39241251 27.04735179 38.67580072 25.94873947 36.96411133 24.8425293 C31.32788604 21.23070772 30.22645012 20.72003038 24.67114258 24.30200195 Z "
        fill={color}
        transform="translate(33.602294921875,9.584716796875)"
      />
      <path
        d="M0 0 C2.37474984 1.20461635 4.62193773 2.46654609 6.86694336 3.8972168 C7.66745117 4.40510742 8.46795898 4.91299805 9.29272461 5.4362793 C10.11643555 5.96479492 10.94014648 6.49331055 11.78881836 7.0378418 C12.59706055 7.55088867 13.40530273 8.06393555 14.23803711 8.5925293 C19.72120536 12.08421084 25.14364295 15.66189508 30.53881836 19.2878418 C29.25269643 23.14620759 27.83478681 23.62606188 24.40209961 25.72143555 C23.34958008 26.37047852 22.29706055 27.01952148 21.21264648 27.68823242 C20.1034082 28.36047852 18.99416992 29.03272461 17.85131836 29.7253418 C15.68032875 31.05669379 13.5097436 32.38870561 11.33959961 33.72143555 C10.3719165 34.30981201 9.4042334 34.89818848 8.40722656 35.50439453 C5.44010166 37.28318365 5.44010166 37.28318365 2.48876953 39.63574219 C-0.46118164 41.2878418 -0.46118164 41.2878418 -3.06787109 40.69873047 C-4.25255981 40.00034058 -4.25255981 40.00034058 -5.46118164 39.2878418 C-6.17169678 38.88605713 -6.88221191 38.48427246 -7.61425781 38.0703125 C-8.32042236 37.62260498 -9.02658691 37.17489746 -9.75415039 36.71362305 C-10.94077271 35.96387207 -10.94077271 35.96387207 -12.15136719 35.19897461 C-12.97548096 34.67142578 -13.79959473 34.14387695 -14.64868164 33.6003418 C-15.49277588 33.06376953 -16.33687012 32.52719727 -17.20654297 31.97436523 C-23.06900833 28.22897964 -28.84126266 24.39081607 -34.46118164 20.2878418 C-29.98413983 16.48554763 -25.12039961 13.44944381 -20.14868164 10.3503418 C-19.33206055 9.83793945 -18.51543945 9.32553711 -17.67407227 8.79760742 C-16.05411832 7.78174786 -14.43030168 6.77201932 -12.80249023 5.76879883 C-11.25946285 4.79278171 -9.73998806 3.77834265 -8.2487793 2.72485352 C-7.56219238 2.24935059 -6.87560547 1.77384766 -6.16821289 1.28393555 C-5.57113525 0.85137451 -4.97405762 0.41881348 -4.35888672 -0.02685547 C-2.46118164 -0.7121582 -2.46118164 -0.7121582 0 0 Z "
        fill={color}
        transform="translate(65.461181640625,77.712158203125)"
      />
    </svg>
  );
};
